export const GOOGLE_MAPS_DEFAUL_LANGUAGE = 'it'